import { Controller } from '@hotwired/stimulus'

interface ActionParams {
  params: {
    id?: string
  }
}

const modalElement = (id?: string): HTMLDialogElement | null => {
  if (id) {
    const elementId = 'modal-container-' + id
    return document.getElementById(elementId) as HTMLDialogElement | null
  } else {
    return document.getElementById('modal-container') as HTMLDialogElement | null
  }
}

export default class extends Controller {
  open({ params: { id } }: ActionParams) {
    const modal = modalElement(id)

    if (!modal) return

    modal.showModal()
  }

  close({ params: { id } }: ActionParams) {
    const modal = modalElement(id)

    if (!modal) return

    modal.close()
  }
}
